<storever-loading-data *ngIf="false else dataForm"></storever-loading-data>
<ng-template #dataForm>
  <form [formGroup]="dataConfig.form" class="formHeight">
    <ul class="list-group">
      <div class="width-33">
        <storever-element-group
          [icon]="'fa-id-card'"
          [title]="'Contact'"
          [config]="dataConfig.groupConfigs.groupConfigs[0].config"
          [form]="getFormAt(0)"
          [isEdit]="!(isStatusOff$|async)"
          [status]="(isOrderOpened()|async) ? '1' : '0'"
          [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-edit', type: 'subscription', case: 'subscription'}"
          (save)="save(['ContactEditComponent', 'contact', ''+0])"
          (undo)="undo(['contact', ''+0])"
          [stylingClass]="'dynamic-form'">
        </storever-element-group>
      </div>
    </ul>
  </form>
</ng-template>
<!--  <pre style="flex:1;word-break:break-word;line-height:2;">form value:{{form.value|json}}</pre>-->
<!-- DEBUG -->
<div *ngIf="false" style="display:flex;">
  <pre>getFormAt(0) dirty: {{getFormAt(0).dirty}}</pre>
</div>

